module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_8019.a449540c.png";